module.exports = __webpack_public_path__ + "img/kobayashi-asuka.6e0389e1.jpg";